import { MARQUEE_ITEMS } from "../data/site";

export default function Marquee() {
    return (
        <div
            className="overflow-hidden border-y border-white/10 bg-abyss py-6"
            aria-label="Pacific Expressway capabilities"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex items-center">
                        {MARQUEE_ITEMS.map((item) => (
                            <span
                                key={`${copy}-${item}`}
                                className="flex items-center whitespace-nowrap"
                            >
                                <span className="font-heading text-xl sm:text-2xl font-semibold uppercase tracking-[0.14em] text-white/25 px-8">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
